import { platform } from 'constants'
import { ScrollView } from 'react-native'
import styled from 'styled-components/native'

import { Box } from 'widgets/Box'

import { ThemeColor } from 'utils/themes/types'

export const MaxWidthContainerBox = styled(Box)`
  max-width: ${({ theme }) => theme.maxWidth}px;
  width: 100%;
  height: 100%;
`

export const StyledScrollView = styled(ScrollView)<{
  backgroundColor?: ThemeColor
}>`
  flex: 1;
  ${({ theme, backgroundColor }) =>
    backgroundColor ? `background-color: ${theme.colors[backgroundColor]}` : ''}
`

export const LoadingOverlayContainer = styled(Box)`
  background-color: ${({ theme }) => theme.colors.black75};
  position: ${platform.IS_WEB ? 'fixed' : 'absolute'};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`
